<script>
import HomeFaq from "@js/components/Sections/Faqs/HomeFaq.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";
import ContactsTopComponent from "@js/components/Sections/TopComponents/ContactsTopComponent.vue";
import FullHeightComponent from "@js/components/DynamicComponents/FullHeightComponent.vue";

export default {
    name: "ContactsPage",
    components: {
        FullHeightComponent,
        ContactsTopComponent,
        HomeFaq,
    },
    beforeMount() {
        this.themeStore.activateDarkTheme()
    },
    setup() {
        const themeStore = useThemeStore()

        return {themeStore}
    },
}
</script>

<template>
    <ContactsTopComponent/>
    <HomeFaq/>
</template>

<style scoped lang="scss">

</style>
